module.exports = __webpack_public_path__ + "img/tryk_og_glad_malesider_3.e4099d04.jpg";